import { PaymentTiming } from "@/types/enums/PaymentTiming"
import { inferCodFromPaymentMethod } from "@/domain/order/order-payment-timing"
import { isCodPaymentTiming, isPrepaidPaymentTiming } from "@/domain/payment/payment-timing"

export type CanRetryPaymentInput = {
  isPaid: boolean
  payableAmount: number
  billingSnapshotId?: string | null
  statusStage: string
  paymentStatus?: string
  paymentTiming?: PaymentTiming
  paymentMethod?: string
}

/**
 * Whether hosted retry / complete-payment should be offered.
 */
export function canRetryPayment(input: CanRetryPaymentInput): boolean {
  const timing = input.paymentTiming ?? PaymentTiming.Unknown
  const stage = input.statusStage.toUpperCase()
  const pay = (input.paymentStatus ?? "").toUpperCase()

  if (isCodPaymentTiming(timing)) return false
  if (timing === PaymentTiming.Unknown && inferCodFromPaymentMethod(input.paymentMethod)) {
    return false
  }
  if (!isPrepaidPaymentTiming(timing)) return false

  return (
    !input.isPaid &&
    input.payableAmount > 0 &&
    Boolean(String(input.billingSnapshotId ?? "").trim()) &&
    !["CANCELLED", "DELIVERED"].includes(stage) &&
    pay !== "SUCCESS"
  )
}
